import React from "react"
import { Box } from "@rebass/grid/emotion"

import Tag from "../../tag/tag"
import GwpAtcTopCard from "./gwpatctopcard"
import { Wrap } from "./gwpatcarea.styled"

const GwpAtcAreaBannerMulti = ({ data, handleGwpModal }) => {
  const {
    card,
    mb = [40, null, 40, 40],
    lineImageMobile,
    lineImage,
    planeImageMobile,
    planeImage,
    tag,
  } = data

  return (
    <Wrap onClick={handleGwpModal} mb={mb} pt={["8px", null, 0]}>
      <Box className="relative line-graphic-box mx-auto text-center">
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet={planeImageMobile || planeImage}
          />
          <source media="(min-width: 768px)" srcSet={planeImage} />
          <img
            src={planeImage}
            alt={``}
            role={`presentation`}
            className="w-full"
          />
        </picture>
        <Box className="tag-box">
          <Tag
            data={{
              line: tag.line,
              classes: "bg-nova-brand-accent-80",
            }}
          />
        </Box>
      </Box>
      <GwpAtcTopCard data={card} />
      <Box>
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet={lineImageMobile || lineImage}
          />
          <source media="(min-width: 768px)" srcSet={lineImage} />
          <img src={lineImage} alt={``} role={`presentation`} />
        </picture>
      </Box>
    </Wrap>
  )
}

export default GwpAtcAreaBannerMulti
